import * as React from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Swal from 'sweetalert2';
import { MenuItem, TextField } from '@mui/material';
import toast from 'react-hot-toast';
import { ReactFormBuilder } from 'react-form-builder2';
import 'react-form-builder2/dist/app.css';

import { createSafalEventBusinessForm, updateSafalEventBusinessForm } from '../../../services/Service';

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90vw',
  bgcolor: 'background.paper',
  border: '1px solid #000',
  borderRadius: '8px',
  boxShadow: 24,
  displey: 'flex',
  flexDirection: 'column',
  gap: '12px',
  p: 4,
  maxHeight: '95vh',
  overflow: 'auto',
  '@media (max-width: 640px)': {
    width: '95vw',
  },
};

const initFieldValue = {
  name: '',
  description: '',
  status: 'Active', // Active, Inactive
  element: [],
};

export default function AddSafalEventBusinessFormModal({ open, onClose, data, isDisplay }) {
  const [fieldValue, setFieldValue] = React.useState({ ...initFieldValue });
  const [isDisableAll, setIsDisableAll] = React.useState(false);

  const handleClose = () => {
    setFieldValue({ ...initFieldValue });
    setIsDisableAll(false);
    onClose();
  };

  const onSubmit = async () => {
    setIsDisableAll(true);

    try {
      const res = await createSafalEventBusinessForm(fieldValue);
      if (res.status === 200) {
        toast.success(res.data.message);
        handleClose();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsDisableAll(false);
    }
  };

  const onUpdateSubmit = async () => {
    setIsDisableAll(true);
    try {
      const res = await updateSafalEventBusinessForm({ ...fieldValue, _id: data._id });
      if (res.status === 200) {
        toast.success(res.data.message);
        handleClose();
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err.message);
    } finally {
      setIsDisableAll(false);
    }
  };

  React.useEffect(() => {
    if (open === true && data !== null) {
      setFieldValue({
        name: data?.name ?? '',
        description: data?.description ?? '',
        status: data?.status ?? '',
        element: data?.element || [],
      });
      setIsDisableAll(isDisplay);
    }
  }, [open, data, isDisplay]);

  const onLoad = async (fieldValue) => {
    return fieldValue.element;
  };

  return (
    <Modal open={open}>
      <Box sx={style}>
        <Typography
          variant="h4"
          gutterBottom
          sx={{ marginBottom: '16px', fontSize: '30px', fontWeight: 700, color: '#19c25f' }}
        >
          {data === null ? 'Add RSVP Form' : isDisplay ? 'RSVP Form' : 'Update RSVP Form'}
        </Typography>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          <div id="DynamicFormDiv">
            {data ? (
              <ReactFormBuilder
                saveAlways
                onLoad={() => onLoad(data)}
                data={fieldValue.element}
                onPost={(data) => {
                  const task_data = data?.task_data || [];
                  setFieldValue((prev) => ({ ...prev, element: task_data }));
                }}
              />
            ) : (
              <ReactFormBuilder
                saveAlways
                onPost={(data) => {
                  const task_data = data?.task_data || [];
                  setFieldValue((prev) => ({ ...prev, element: task_data }));
                }}
              />
            )}
          </div>
          <div style={{ display: 'flex', gap: '12px' }}>
            <div style={{ flex: 1 }}>
              {/* name */}
              <TextField
                value={fieldValue.name}
                onChange={(e) => setFieldValue((prev) => ({ ...prev, name: e.target.value }))}
                required
                label="Name"
                size="small"
                type="text"
                fullWidth
                variant="outlined"
                disabled={isDisableAll}
              />
            </div>
            <div style={{ flex: 1 }}>
              {/* status */}
              <TextField
                value={fieldValue.status}
                onChange={(e) => setFieldValue((prev) => ({ ...prev, status: e.target.value }))}
                required
                select
                label="Status"
                size="small"
                fullWidth
                variant="outlined"
                disabled={isDisableAll}
              >
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="Inactive">Inactive</MenuItem>
              </TextField>
            </div>
          </div>
          {/* description */}
          <TextField
            value={fieldValue.description}
            onChange={(e) => setFieldValue((prev) => ({ ...prev, description: e.target.value }))}
            label="description"
            size="small"
            type="text"
            fullWidth
            variant="outlined"
            disabled={isDisableAll}
          />
        </div>
        <div style={{ display: 'flex', gap: '12px', marginTop: '16px', justifyContent: 'end' }}>
          <Button
            disabled={isDisplay ? false : isDisableAll}
            onClick={handleClose}
            sx={{ backgroundColor: '#19c25f', textTransform: 'capitalize' }}
            variant="contained"
          >
            Cancel
          </Button>
          {!isDisplay && (
            <Button
              disabled={isDisableAll}
              onClick={data === null ? onSubmit : onUpdateSubmit}
              sx={{ backgroundColor: '#19c25f', textTransform: 'capitalize' }}
              variant="contained"
            >
              {data === null ? 'Create' : 'Update'}
            </Button>
          )}
        </div>
      </Box>
    </Modal>
  );
}
